<!-- Hero Section -->
<section class="solutions-hero">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-lg-8 text-center">
        <span class="hero-badge">{{ 'solutions.hero.badge' | translate }}</span>
        <h1 class="hero-title">{{ 'solutions.hero.title' | translate }}</h1>
        <p class="hero-subtitle">{{ 'solutions.hero.subtitle' | translate }}</p>
        <div class="hero-buttons">
          <a routerLink="/auth/register-user" class="btn-primary-lg">
            {{ 'solutions.hero.startTrial' | translate }}
            <i class="fa fa-arrow-right ms-2"></i>
          </a>
          <a href="#features" class="btn-secondary-lg">
            {{ 'solutions.hero.exploreFeatures' | translate }}
          </a>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Who It's For Section -->
<section class="who-section">
  <div class="container" style="max-width: 1200px">
    <div class="text-center mb-5">
      <span class="section-badge">{{ 'solutions.whoFor.badge' | translate }}</span>
      <h2 class="section-title">{{ 'solutions.whoFor.title' | translate }}</h2>
    </div>

    <div class="row g-4">
      <div class="col-lg-4">
        <div class="who-card">
          <div class="who-icon">
            <i class="fa fa-home"></i>
          </div>
          <h3>{{ 'solutions.whoFor.ridingSchools' | translate }}</h3>
          <p>{{ 'solutions.whoFor.ridingSchoolsDesc' | translate }}</p>
          <ul class="who-features">
            <li><i class="fa fa-check"></i> {{ 'solutions.whoFor.lessonScheduling' | translate }}</li>
            <li><i class="fa fa-check"></i> {{ 'solutions.whoFor.studentProgress' | translate }}</li>
            <li><i class="fa fa-check"></i> {{ 'solutions.whoFor.instructorManagement' | translate }}</li>
            <li><i class="fa fa-check"></i> {{ 'solutions.whoFor.schoolHorse' | translate }}</li>
          </ul>
        </div>
      </div>

      <div class="col-lg-4">
        <div class="who-card">
          <div class="who-icon">
            <i class="fa fa-users"></i>
          </div>
          <h3>{{ 'solutions.whoFor.ridingClubs' | translate }}</h3>
          <p>{{ 'solutions.whoFor.ridingClubsDesc' | translate }}</p>
          <ul class="who-features">
            <li><i class="fa fa-check"></i> {{ 'solutions.whoFor.membershipManagement' | translate }}</li>
            <li><i class="fa fa-check"></i> {{ 'solutions.whoFor.eventOrganization' | translate }}</li>
            <li><i class="fa fa-check"></i> {{ 'solutions.whoFor.communicationTools' | translate }}</li>
            <li><i class="fa fa-check"></i> {{ 'solutions.whoFor.memberPortal' | translate }}</li>
          </ul>
        </div>
      </div>

      <div class="col-lg-4">
        <div class="who-card">
          <div class="who-icon">
            <i class="fa fa-trophy"></i>
          </div>
          <h3>{{ 'solutions.whoFor.eventOrganizers' | translate }}</h3>
          <p>{{ 'solutions.whoFor.eventOrganizersDesc' | translate }}</p>
          <ul class="who-features">
            <li><i class="fa fa-check"></i> {{ 'solutions.whoFor.onlineRegistration' | translate }}</li>
            <li><i class="fa fa-check"></i> {{ 'solutions.whoFor.classManagement' | translate }}</li>
            <li><i class="fa fa-check"></i> {{ 'solutions.whoFor.resultsRankings' | translate }}</li>
            <li><i class="fa fa-check"></i> {{ 'solutions.whoFor.paymentProcessing' | translate }}</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Main Features Section -->
<section class="features-main" id="features">
  <div class="container" style="max-width: 1200px">
    <div class="text-center mb-5">
      <span class="section-badge">{{ 'solutions.features.badge' | translate }}</span>
      <h2 class="section-title">{{ 'solutions.features.title' | translate }}</h2>
      <p class="section-subtitle">{{ 'solutions.features.subtitle' | translate }}</p>
    </div>

    <!-- Feature 1: Member Management -->
    <div class="feature-block">
      <div class="row align-items-center g-5">
        <div class="col-lg-6">
          <div class="feature-content">
            <div class="feature-badge">{{ 'solutions.features.members.badge' | translate }}</div>
            <h3 class="feature-title">{{ 'solutions.features.members.title' | translate }}</h3>
            <p class="feature-text">{{ 'solutions.features.members.description' | translate }}</p>
            <ul class="feature-list">
              <li>
                <i class="fa fa-check-circle"></i>
                <div>
                  <strong>{{ 'solutions.features.members.automatedRenewals' | translate }}</strong>
                  <span>{{ 'solutions.features.members.automatedRenewalsDesc' | translate }}</span>
                </div>
              </li>
              <li>
                <i class="fa fa-check-circle"></i>
                <div>
                  <strong>{{ 'solutions.features.members.memberProfiles' | translate }}</strong>
                  <span>{{ 'solutions.features.members.memberProfilesDesc' | translate }}</span>
                </div>
              </li>
              <li>
                <i class="fa fa-check-circle"></i>
                <div>
                  <strong>{{ 'solutions.features.members.membershipTiers' | translate }}</strong>
                  <span>{{ 'solutions.features.members.membershipTiersDesc' | translate }}</span>
                </div>
              </li>
              <li>
                <i class="fa fa-check-circle"></i>
                <div>
                  <strong>{{ 'solutions.features.members.selfServicePortal' | translate }}</strong>
                  <span>{{ 'solutions.features.members.selfServicePortalDesc' | translate }}</span>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="col-lg-6">
          <div class="feature-image">
            <img src="assets/images/feature-members.png" [alt]="'solutions.features.members.title' | translate" />
          </div>
        </div>
      </div>
    </div>

    <!-- Feature 2: Event Management -->
    <div class="feature-block feature-block-reverse">
      <div class="row align-items-center g-5">
        <div class="col-lg-6 order-lg-2">
          <div class="feature-content">
            <div class="feature-badge">{{ 'solutions.features.events.badge' | translate }}</div>
            <h3 class="feature-title">{{ 'solutions.features.events.title' | translate }}</h3>
            <p class="feature-text">{{ 'solutions.features.events.description' | translate }}</p>
            <ul class="feature-list">
              <li>
                <i class="fa fa-check-circle"></i>
                <div>
                  <strong>{{ 'solutions.features.events.onlineRegistration' | translate }}</strong>
                  <span>{{ 'solutions.features.events.onlineRegistrationDesc' | translate }}</span>
                </div>
              </li>
              <li>
                <i class="fa fa-check-circle"></i>
                <div>
                  <strong>{{ 'solutions.features.events.classBuilder' | translate }}</strong>
                  <span>{{ 'solutions.features.events.classBuilderDesc' | translate }}</span>
                </div>
              </li>
              <li>
                <i class="fa fa-check-circle"></i>
                <div>
                  <strong>{{ 'solutions.features.events.resultsRankings' | translate }}</strong>
                  <span>{{ 'solutions.features.events.resultsRankingsDesc' | translate }}</span>
                </div>
              </li>
              <li>
                <i class="fa fa-check-circle"></i>
                <div>
                  <strong>{{ 'solutions.features.events.paymentProcessing' | translate }}</strong>
                  <span>{{ 'solutions.features.events.paymentProcessingDesc' | translate }}</span>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="col-lg-6 order-lg-1">
          <div class="feature-image">
            <img src="assets/images/feature-events.png" [alt]="'solutions.features.events.title' | translate" />
          </div>
        </div>
      </div>
    </div>

    <!-- Feature 3: Horse Database -->
    <div class="feature-block">
      <div class="row align-items-center g-5">
        <div class="col-lg-6">
          <div class="feature-content">
            <div class="feature-badge">{{ 'solutions.features.horses.badge' | translate }}</div>
            <h3 class="feature-title">{{ 'solutions.features.horses.title' | translate }}</h3>
            <p class="feature-text">{{ 'solutions.features.horses.description' | translate }}</p>
            <ul class="feature-list">
              <li>
                <i class="fa fa-check-circle"></i>
                <div>
                  <strong>{{ 'solutions.features.horses.horseProfiles' | translate }}</strong>
                  <span>{{ 'solutions.features.horses.horseProfilesDesc' | translate }}</span>
                </div>
              </li>
              <li>
                <i class="fa fa-check-circle"></i>
                <div>
                  <strong>{{ 'solutions.features.horses.healthRecords' | translate }}</strong>
                  <span>{{ 'solutions.features.horses.healthRecordsDesc' | translate }}</span>
                </div>
              </li>
              <li>
                <i class="fa fa-check-circle"></i>
                <div>
                  <strong>{{ 'solutions.features.horses.competitionHistory' | translate }}</strong>
                  <span>{{ 'solutions.features.horses.competitionHistoryDesc' | translate }}</span>
                </div>
              </li>
              <li>
                <i class="fa fa-check-circle"></i>
                <div>
                  <strong>{{ 'solutions.features.horses.ownershipLeases' | translate }}</strong>
                  <span>{{ 'solutions.features.horses.ownershipLeasesDesc' | translate }}</span>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="col-lg-6">
          <div class="feature-image">
            <img src="assets/images/feature-horses.png" [alt]="'solutions.features.horses.title' | translate" />
          </div>
        </div>
      </div>
    </div>

    <!-- Feature 4: Booking System -->
    <div class="feature-block feature-block-reverse">
      <div class="row align-items-center g-5">
        <div class="col-lg-6 order-lg-2">
          <div class="feature-content">
            <div class="feature-badge">{{ 'solutions.features.booking.badge' | translate }}</div>
            <h3 class="feature-title">{{ 'solutions.features.booking.title' | translate }}</h3>
            <p class="feature-text">{{ 'solutions.features.booking.description' | translate }}</p>
            <ul class="feature-list">
              <li>
                <i class="fa fa-check-circle"></i>
                <div>
                  <strong>{{ 'solutions.features.booking.onlineBooking' | translate }}</strong>
                  <span>{{ 'solutions.features.booking.onlineBookingDesc' | translate }}</span>
                </div>
              </li>
              <li>
                <i class="fa fa-check-circle"></i>
                <div>
                  <strong>{{ 'solutions.features.booking.instructorSchedules' | translate }}</strong>
                  <span>{{ 'solutions.features.booking.instructorSchedulesDesc' | translate }}</span>
                </div>
              </li>
              <li>
                <i class="fa fa-check-circle"></i>
                <div>
                  <strong>{{ 'solutions.features.booking.arenaManagement' | translate }}</strong>
                  <span>{{ 'solutions.features.booking.arenaManagementDesc' | translate }}</span>
                </div>
              </li>
              <li>
                <i class="fa fa-check-circle"></i>
                <div>
                  <strong>{{ 'solutions.features.booking.automaticReminders' | translate }}</strong>
                  <span>{{ 'solutions.features.booking.automaticRemindersDesc' | translate }}</span>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="col-lg-6 order-lg-1">
          <div class="feature-image">
            <img src="assets/images/feature-booking.png" [alt]="'solutions.features.booking.title' | translate" />
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Additional Features Grid -->
<section class="features-grid-section">
  <div class="container" style="max-width: 1200px">
    <div class="text-center mb-5">
      <span class="section-badge">{{ 'solutions.more.badge' | translate }}</span>
      <h2 class="section-title">{{ 'solutions.more.title' | translate }}</h2>
    </div>

    <div class="row g-4">
      <div class="col-lg-4 col-md-6">
        <div class="feature-grid-card">
          <div class="feature-grid-icon">
            <i class="fa fa-credit-card"></i>
          </div>
          <h4>{{ 'solutions.more.onlinePayments' | translate }}</h4>
          <p>{{ 'solutions.more.onlinePaymentsDesc' | translate }}</p>
        </div>
      </div>

      <div class="col-lg-4 col-md-6">
        <div class="feature-grid-card">
          <div class="feature-grid-icon">
            <i class="fa fa-envelope"></i>
          </div>
          <h4>{{ 'solutions.more.emailMarketing' | translate }}</h4>
          <p>{{ 'solutions.more.emailMarketingDesc' | translate }}</p>
        </div>
      </div>

      <div class="col-lg-4 col-md-6">
        <div class="feature-grid-card">
          <div class="feature-grid-icon">
            <i class="fa fa-chart-bar"></i>
          </div>
          <h4>{{ 'solutions.more.reportsAnalytics' | translate }}</h4>
          <p>{{ 'solutions.more.reportsAnalyticsDesc' | translate }}</p>
        </div>
      </div>

      <div class="col-lg-4 col-md-6">
        <div class="feature-grid-card">
          <div class="feature-grid-icon">
            <i class="fa fa-mobile-alt"></i>
          </div>
          <h4>{{ 'solutions.more.mobileFriendly' | translate }}</h4>
          <p>{{ 'solutions.more.mobileFriendlyDesc' | translate }}</p>
        </div>
      </div>

      <div class="col-lg-4 col-md-6">
        <div class="feature-grid-card">
          <div class="feature-grid-icon">
            <i class="fa fa-lock"></i>
          </div>
          <h4>{{ 'solutions.more.secureReliable' | translate }}</h4>
          <p>{{ 'solutions.more.secureReliableDesc' | translate }}</p>
        </div>
      </div>

      <div class="col-lg-4 col-md-6">
        <div class="feature-grid-card">
          <div class="feature-grid-icon">
            <i class="fa fa-headset"></i>
          </div>
          <h4>{{ 'solutions.more.expertSupport' | translate }}</h4>
          <p>{{ 'solutions.more.expertSupportDesc' | translate }}</p>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Integration Section -->
<section class="integrations-section">
  <div class="container" style="max-width: 1000px">
    <div class="row align-items-center g-5">
      <div class="col-lg-6">
        <span class="section-badge">{{ 'solutions.integrations.badge' | translate }}</span>
        <h2 class="section-title">{{ 'solutions.integrations.title' | translate }}</h2>
        <p class="section-text">{{ 'solutions.integrations.description' | translate }}</p>
        <ul class="integrations-list">
          <li><i class="fa fa-check-circle"></i> {{ 'solutions.integrations.accounting' | translate }}</li>
          <li><i class="fa fa-check-circle"></i> {{ 'solutions.integrations.calendar' | translate }}</li>
          <li><i class="fa fa-check-circle"></i> {{ 'solutions.integrations.payments' | translate }}</li>
          <li><i class="fa fa-check-circle"></i> {{ 'solutions.integrations.email' | translate }}</li>
        </ul>
      </div>
      <div class="col-lg-6">
        <div class="integrations-grid">
          <div class="integration-logo"><img src="assets/images/logo-stripe.png" alt="Stripe" /></div>
          <div class="integration-logo"><img src="assets/images/logo-quickbooks.png" alt="QuickBooks" /></div>
          <div class="integration-logo"><img src="assets/images/logo-google.png" alt="Google" /></div>
          <div class="integration-logo"><img src="assets/images/logo-mailchimp.png" alt="Mailchimp" /></div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- CTA Section -->
<section class="cta-section">
  <div class="container text-center">
    <div class="row justify-content-center">
      <div class="col-lg-8">
        <h2 class="cta-title">{{ 'solutions.cta.title' | translate }}</h2>
        <p class="cta-text">{{ 'solutions.cta.description' | translate }}</p>
        <div class="cta-buttons">
          <a routerLink="/auth/register-user" class="btn-cta-primary">
            {{ 'solutions.cta.startTrial' | translate }}
            <i class="fa fa-arrow-right ms-2"></i>
          </a>
          <a routerLink="/pricing" class="btn-cta-secondary">
            {{ 'solutions.cta.viewPricing' | translate }}
          </a>
        </div>
      </div>
    </div>
  </div>
</section>
